import { Loader2 } from "lucide-react";

interface ToolCallIndicatorProps {
  toolName: string;
}

const TOOL_LABELS: Record<string, string> = {
  search_locations: "Searching locations...",
  get_location_detail: "Looking up details...",
  get_aggregate_stats: "Calculating stats...",
};

export function ToolCallIndicator({ toolName }: ToolCallIndicatorProps) {
  const label = TOOL_LABELS[toolName] || "Processing...";

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 text-xs text-muted-foreground">
      <Loader2 className="h-3 w-3 animate-spin" />
      <span>{label}</span>
    </div>
  );
}
